export const FETCHED_AGE_GROUPS = 'FETCHED_AGE_GROUPS';
export const FETCHED_REVIEWS_BY_SEARCH_TERMS = 'FETCHED_REVIEWS_BY_SEARCH_TERMS';
export const REVIEW_SEARCH_BY_AUTHOR = 'REVIEW_SEARCH_BY_AUTHOR';
export const CLEAR_REVIEWS_SEARCH_FILTER = 'CLEAR_REVIEWS_SEARCH_FILTER';


// WEBPACK FOOTER //
// ./src/containers/reviews/types.js